require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2007-01-21-personal-e-mail-is-dead-to-me.json") })
        }
      }, "path---articles-2007-01-21-personal-e-mail-is-dead-to-me");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2007-01-21-personal-e-mail-is-dead-to-me!./.cache/json/articles-2007-01-21-personal-e-mail-is-dead-to-me.json
// module id = 501
// module chunks = 231608221292675